import { GenIcon } from 'react-icons';
export const MdUmbrellaOpen = GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 21 21' },
    child: [
        {
            tag: 'path',
            attr: {
                d: 'M11.111 18.038a2.5 2.5 0 0 1-5 0v-.5h2v.5a.5.5 0 0 0 1 0v-6.5h2zM10.133 0a10.09 10.09 0 0 1 7.135 2.963 10.09 10.09 0 0 1 2.962 7.148L0 10.12C0 4.533 4.533 0 10.12 0zm-3.55 2.814a8.064 8.064 0 0 0-4.342 5.303l1.96.008a11.3 11.3 0 0 1 2.382-5.31m3.528-.502C8.125 3.622 6.753 5.714 6.258 8.118h7.708c-.368-1.796-1.217-3.421-2.49-4.694a8.6 8.6 0 0 0-1.365-1.11m3.529.502a11.25 11.25 0 0 1 2.376 5.303h1.965a8.06 8.06 0 0 0-4.341-5.303',
            },
            child: [],
        },
    ],
});
